import { useTranslation } from 'react-i18next';

import AlertFill from '@/assets/icons/alert_fill.svg?component';
import CheckFill from '@/assets/icons/check_fill.svg?component';
import TimeFill from '@/assets/icons/time_fill.svg?component';
import { Badge, type BadgeTone } from '@/components/atoms/Badge';
import { SvgIcon, type SvgIconProps } from '@/components/atoms/SvgIcon/SvgIcon';

export type LicenseStatus = 'active' | 'expired' | 'upcoming';

interface LicenseStatusBadgeProps {
    status: LicenseStatus;
    className?: string;
}

const statusIcons: Record<LicenseStatus, SvgIconProps['icon']> = {
    active: CheckFill,
    expired: AlertFill,
    upcoming: TimeFill,
};

const statusTones: Record<LicenseStatus, BadgeTone> = {
    active: 'success',
    expired: 'danger',
    upcoming: 'neutral',
};

export default function LicenseStatusBadge(props: LicenseStatusBadgeProps) {
    const { status, className } = props;
    const { t } = useTranslation();

    return (
        <Badge
            tone={statusTones[status]}
            size="md"
            className={className}
            icon={
                <SvgIcon
                    icon={statusIcons[status]}
                    size="inherit"
                    svgProps={{ 'aria-hidden': true }}
                />
            }>
            {t(`bioscopeContracts.licenseStatus.${status}`)}
        </Badge>
    );
}
